import imageCompression from 'browser-image-compression';

export const journalPhotoMaxBytes = 1536 * 1024;

const supportedPhoto = async (file) => {
  const bytes = new Uint8Array(await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Foto tidak dapat dibaca. Pilih ulang dari galeri.'));
    reader.readAsArrayBuffer(file.slice(0, 12));
  }));
  return (bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255)
    || bytes.slice(0, 8).join(',') === '137,80,78,71,13,10,26,10'
    || (String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF'
      && String.fromCharCode(...bytes.slice(8, 12)) === 'WEBP');
};

export async function prepareJournalPhoto(file) {
  if (!file?.size) throw new Error('Foto kosong. Pilih ulang dari galeri.');
  if (file.size > 20 * 1024 * 1024) throw new Error('Foto terlalu besar. Pilih foto maksimal 20 MB.');
  if (file.size <= journalPhotoMaxBytes && await supportedPhoto(file)) return file;

  // Four photos stay below the server's 7 MB request limit, matching Flutter.
  for (const [dimension, quality] of [[1600, 0.8], [1280, 0.7]]) {
    const controller = new AbortController();
    let timer;
    try {
      const output = await Promise.race([
        imageCompression(file, {
          maxSizeMB: 1.5, maxWidthOrHeight: dimension, initialQuality: quality,
          maxIteration: 1, fileType: 'image/jpeg', useWebWorker: true, signal: controller.signal,
        }),
        new Promise((_, reject) => {
          timer = setTimeout(() => {
            controller.abort();
            reject(new Error('Pemrosesan foto terlalu lama.'));
          }, 20000);
        }),
      ]);
      if (output?.size > 0 && output.size <= journalPhotoMaxBytes && await supportedPhoto(output)) {
        return new File([output], `${file.name.replace(/\.[^.]+$/, '')}.jpg`, { type: 'image/jpeg' });
      }
    } catch (_) {
      break;
    } finally {
      clearTimeout(timer);
    }
  }
  throw new Error('Foto belum dapat disiapkan. Pilih foto JPG/PNG/WebP maksimal 1,5 MB, atau ambil ulang foto.');
}
